const languages = {
  newGame: ["New game", "Nowa gra"],
  mainMenu: ["Main menu", "Główne menu"],
  goBack: ["Go back", "Wróć"],
  createGame: ["Create game", "Stwórz grę"],
  joinGame: ["Join game", "Dołącz do gry"],
  multiplayer: ["Multiplayer", "Gra wieloosobowa"],
  options: ["Options", "Opcje"],
  howToPlay: ["How to play", "Jak grać"],
  players: ["Players", "Gracze"],
  spies: ["Spies", "Szpiedzy"],
  gameLength: ["Game length", "Długość gry"],
  discussion: ["Discussion", "Dyskusja"],
  over: ["over", "koniec"],
  sound: ["Sound", "Dźwięk"],
  language: ["Language", "Język"],
  preventScreenSleep: ["Screen sleep", "Wygaszenie ekranu"],
  rolesAsigned: ["Roles have been asigned", "Role przypisane"],
  startGame: ["Start game", "Zacznij grę"],
  player: ["Player", "Gracz"],
  ok: ["Ok", "Ok"],
  showInfo: ["Show info", "Pokaż informacje"],
  youAre: ["You are", "Jesteś"],
  spy: ["Spy", "Szpiegiem"],
  ready: ["Ready", "Gotów"],
  notReady: ["Not ready", "Nie gotów"],
  htp1: ["All players except spy are given a place and their role. Spy doesn't know the location and needs to figure it out. Others have to reveal the spy.", "Wszystkim graczom oprócz szpiega zostają przypisane miejsce i ich role. Szpieg nie zna lokacji, w której znajdują się gracze i musi je ustalić. Inni muszą nakryć szpiega."],
  htp2: ["Players are given a set amount of time and take turns asking others. For example player 1 starts the game by asking player 3 e.g. 'Is the environment here rather loud or quiet?'. Player 3 answers the question, then chooses the next person he wants to ask and so on.", "Gracze mają do dyspozycji ustaloną ilość czasu i zadają pytania sobie nawzajem na zmiane. Na przykład gracz 1 rozpoczyna grę pytając gracza 3 np. 'Czy otoczenie gdzie przebywamy jest głośne czy raczej ciche?'. Gracz 3 odpowiada na pytanie, a następnie pyta wybraną przez siebie osobę i tak dalej."],
  htp3: ["After the time expires, players can't ask more questions, but can discuss anything that happened before. If there's nothing left to say everyone votes one person that they think the spy is.", "Po tym jak czas dobiegnie końca, gracze nie mogą zadawać więcej pytań, ale mogą prowadzić dyskusję na temat wcześniej udzielonych odpowiedzi. Jeżeli nie ma już nic do dodania, wszyscy gracze wskazują osobę, która według nich jest szpiegiem."],
  htp4: ["If players voted not the spy, spy wins. If they vote correctly, spy gets one shot at guessing the location. If the spy guessed right, spy wins, otherwise players win.", "Jeżeli gracze wybrali osobę, która nie była szpiegiem, szpieg wygrywa. Jeżeli wybrali poprawnie, szpieg ma jedną szansę na odgadnięcie lokacji. Jeżeli szpieg odgadnie miejsce, wygrywa, w przeciwnym razie gracze wygrywają."],
  roomCode: ["ROOM CODE", "KOD POKOJU"],
  code: ["CODE", "KOD"],
  yourName: ["YOUR NAME", "TWOJE IMIE"],
  typeMessage: ["Type messgage...", "Napisz wiadomość..."],
  send: ["Send", "Wyślij"],
  errNameEmpty: ["Name can't be blank", "Imię nie może być puste"],
  errNameLong: ["Name too long, max 12 characters", "Imię za długie, max 12 znaki"],
  errConnection: ["Couldn't connect to the server", "Błąd podczas próby połączenia z serwerem"],
  errInvalidCode: ["Invalid room code", "Niewłaściwy kod pokoju"],
  errGameInProgress: ["Game is already in progress", "Gra się już zaczęła"],
  copied: ["COPIED", "SKOPIOWANO"],
}

export default languages